export const routes = {
  home: '/',
  account: '/my-account',
  config_screen: '/config_screen',
  my_screens: '/screens',
  templates: '/admin/templates',
  adminHelp: '/admin/help',
  companies: '/admin/companies',
  companyDetail: '/admin/companies/:id',
  users: '/admin/users',
  dashboard: '/admin/dashboard',
  designSystem: '/design-system',
  help: '/help',
  legalMentions: '/legal-mentions',
  cgu: '/CGU',
  politics: '/politique_de_confidentialite',
  params: '/parameters',
  source_data: '/sources',
  media_library: '/media',
  agencies_members: '/members',
  register: '/register',
  change_offer: '/change_offer',
  registered: '/registered',
  subscription: '/subscription',
  subscribe: '/subscribe',
  flows: {
    add: '/flows/add',
    update: '/flows/:id',
    list: '/flows',
  },
  claptech_account: {
    modify_account: '/my-account',
  },
}
